// Title screen (GDD §14.1): logo, name field, one PLAY button, best-speed
// line if a local record exists. No sign-in, no modals.

import { theme } from '../render/theme.js';

const NAME_KEY = 'hexline.name';
const BEST_KEY = 'hexline.bestSpeed';

export function getBestSpeed(): number {
  const raw = localStorage.getItem(BEST_KEY);
  const n = raw === null ? NaN : Number.parseFloat(raw);
  return Number.isFinite(n) ? n : 0;
}

export function recordBestSpeed(speed: number): void {
  if (speed > getBestSpeed()) localStorage.setItem(BEST_KEY, speed.toFixed(1));
}

/** Mount the title overlay; resolves with the chosen name when PLAY is hit. */
export function showTitleScreen(root: HTMLElement): Promise<{ name: string }> {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.style.cssText = `position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:22px;background:#070a10;font-family:system-ui,sans-serif;z-index:10;`;

    const logo = document.createElement('div');
    logo.textContent = 'HEXLINE';
    logo.style.cssText = `font-size:64px;font-weight:800;letter-spacing:14px;color:${theme.text};text-shadow:0 0 30px rgba(120,160,255,.4);`;
    overlay.appendChild(logo);

    const best = getBestSpeed();
    if (best > 0) {
      const bestEl = document.createElement('div');
      bestEl.textContent = `Your best speed: ${best.toFixed(1)}`;
      bestEl.style.cssText = `font-size:14px;color:${theme.textDim};`;
      overlay.appendChild(bestEl);
    }

    const nameInput = document.createElement('input');
    nameInput.maxLength = 16;
    nameInput.placeholder = 'your name';
    nameInput.value = localStorage.getItem(NAME_KEY) ?? '';
    nameInput.style.cssText = `width:220px;padding:10px 14px;font-size:16px;text-align:center;color:${theme.text};background:rgba(20,26,42,.8);border:1px solid rgba(140,160,200,.3);border-radius:8px;outline:none;`;
    overlay.appendChild(nameInput);

    const play = document.createElement('button');
    play.textContent = 'PLAY';
    play.style.cssText = `width:220px;padding:12px 0;font-size:18px;font-weight:700;letter-spacing:4px;color:#0a0e1a;background:#cfe0ff;border:none;border-radius:8px;cursor:pointer;`;
    overlay.appendChild(play);

    const go = (): void => {
      const name = nameInput.value.trim().slice(0, 16) || 'anon';
      localStorage.setItem(NAME_KEY, name);
      overlay.remove();
      resolve({ name });
    };
    play.addEventListener('click', go);
    nameInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') go();
    });

    root.appendChild(overlay);
    nameInput.focus();
  });
}
